var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasData)?_c('e-chart',{attrs:{"options":_vm.chartOptions,"autoresize":""}}):(_vm.loaded)?_c('div',[_vm._v(" "+_vm._s(_vm.$t("No Data Available"))+" ")]):_c('SpinnerCmpt')}
var staticRenderFns = []

export { render, staticRenderFns }